import Backbone from 'backbone';

import difference from 'lodash/difference';
import isEmpty from 'lodash/isEmpty';
import intersection from 'lodash/intersection';
import uniq from 'lodash/uniq';
import without from 'lodash/without';

import { NoSyncMixin } from 'zoomforth_zfutils/backbone_no_sync_model_mixin.js';
import { ALL_MEDIA_LIBRARY_ASSET_TYPES } from 'zoomforth_media_library/const.js';


const MediaLibraryState = Backbone.Model.extend({
  ...NoSyncMixin, 

  constructor: function({ 
      media_types_search, 
      ...attrs 
    }, { 
      // These are options rather than attrs because the enabledMediaType should never
      // change over the lifetime of this view (and also should never be persisted
      // into the URL bar nor localStorage)
      enabledMediaTypes=ALL_MEDIA_LIBRARY_ASSET_TYPES, 
      ...opts 
    }) {
    const newAttrs = {
      ...attrs, 
      // Never include filters that aren't also enabled
      media_types_search: intersection(media_types_search, enabledMediaTypes)
    };
    const newOpts = {
      ...opts,
      enabledMediaTypes
    };
    Backbone.Model.prototype.constructor.call(this, newAttrs, newOpts);
  },

  initialize: function(attrs={}, { enabledMediaTypes }={}) {
    this.enabledMediaTypes = enabledMediaTypes;
  },

  navigate: function(attrs, opts) {
    this.set(attrs, opts);
  },
  
  getEnabledMediaTypes() {
    return this.enabledMediaTypes;
  },

  getHasDisabledMediaTypes() {
    return !isEmpty(difference(ALL_MEDIA_LIBRARY_ASSET_TYPES, this.getEnabledMediaTypes()));
  },

  getMediaTypesSearch() {
    return this.get('media_types_search');
  },

  getIsSearchingByMediaTypes: function() {
    return !isEmpty(this.getMediaTypesSearch());
  },

  getTextSearch() {
    return this.get('text_search');
  },

  getIsSearchingByText() {
    return !!this.getTextSearch();
  },

  getHasChangedIsSearching() {
    return this.hasChanged('text_search') || this.hasChanged('media_types_search');
  },

  getIsSearching: function() {
    return this.getIsSearchingByText() || this.getIsSearchingByMediaTypes();
  },
  
  addMediaTypeSearch: function(mediaType){
    this.navigate({
      media_types_search: uniq([ ...this.get('media_types_search'), mediaType])
    });
  },
  
  removeMediaTypeSearch: function(mediaType) {
    this.navigate({
      'media_types_search': without(this.get('media_types_search'), mediaType)
    });
  },
  
  clearSearch: function(){
    this.navigate({
      text_search: '',
      media_types_search: []
    });
  },

  navigateToFolderId: function(folderId) {
    this.navigate({
      text_search: '',
      media_types_search: [],
      folder_id: folderId
    });
  }
    
}
);

export default MediaLibraryState;
